import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer';
import { PtAwardedSettings } from "../../model/PointData";

export type PointCodePDFProps = {
  ptAwarded: PtAwardedSettings;
  qrCodeData: string;
};

export const PointCodePDF = ({ ptAwarded, qrCodeData }: PointCodePDFProps) => {

  Font.register({
    family: "BIZUDPGothic",
    fonts: [
      {
        src: "/fonts/BIZUDPGothic-Regular.ttf",
      },
      {
        src: "/fonts/BIZUDPGothic-Bold.ttf",
        fontWeight: "bold",
      },
    ],
  });

  const styles = StyleSheet.create({
    page: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#FFFFFF',
      fontFamily: "BIZUDPGothic",
      fontWeight: "bold",
      justifyContent: 'center',
      alignItems: 'center',
    },
    contentContainer: {
      width: '90%',
      alignItems: 'center',
    },
    textContainer: {
      width: '80%',
      margin: '0 auto',
      textAlign: 'center',
      alignItems: 'center',
    },
    name: {
      fontSize: 25,
      textAlign: 'center',
      lineHeight: 1.2,
    },
    titleLeft: {
      textAlign: 'left',
    },
    titleContainer: {
      marginBottom: 20,
    },
    point: {
      fontSize: 20,
      marginBottom: 10,
      textAlign: 'center',
    },
    qrCode: {
      width: 300,
      height: 300,
      margin: 0,
      textAlign: 'center',
    },
  });

  return(
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.contentContainer}>
          <View style={styles.textContainer}>
            <View style={styles.titleContainer}>
              <Text style={styles.name}>{ptAwarded.name}</Text>
            </View>
            <Text style={styles.point}>{`【ポイント数】${ptAwarded.basePoint ? ptAwarded.basePoint : ""}`}</Text>
          </View>
          <Image src={`${qrCodeData}`} style={styles.qrCode}/>
        </View>
      </Page>
    </Document>
  );
};